import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOffersCphOsl,
  alternativeOffersOslCph,
  orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip,
  orderWithRoundTripBothBoundScheduleChange,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const roundTripBothBoundScheduleChangeMock: MockMap = {
  retrieveOrder: [createMockData(orderWithRoundTripBothBoundScheduleChange, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip, [], [orderNotEligibleForRefundWarning])],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl), createMockData(alternativeOffersOslCph)]
};
